import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export const PageRegister: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="mx-auto p-6 rounded-lg shadow-lg bg-white max-w-sm">
      <p className="text-gray-500 mb-5">
        Das Buchungsystem der Ostertaler Begfreunde ist nur für Vereinsmitglieder. Ein Account kann für Sie nur durch
        unseren Hauswart angelegt werden. Bitte kontaktieren Sie diesen per E-Mail oder Telefon.
      </p>
      <Button className="w-full" onClick={() => {navigate("/login")}}>
        Zurück
      </Button>
    </div>
  );
};
